import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  TextField,
} from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { get } from 'lodash';
import Autocomplete from '@mui/material/Autocomplete';

interface IAutocomplete extends React.HTMLAttributes<HTMLDivElement> {
  options: any;
  isRequired?: boolean;
  getevent?: any;
  fieldWidth?: string;
  label?: string;
  name?: string;
  variant?:'standard'
}


function AutocompleteComponent(autocompleteProps: IAutocomplete) {
  const {
      label,
      options,
      id,
      name,
      variant,
      isRequired,
      fieldWidth,
  } = autocompleteProps;
  const { setFieldValue } = useFormikContext();

  const handleChange = (event, value) => {
    setFieldValue(name, value);
  };

  return (
    <Field name={name}>
      {({ field, form: { touched, errors, submitCount, initialValues } }) => {
        const error =
          get(touched, field.name) || submitCount
            ? get(errors, field.name)
            : false;
        const initialValue = get(initialValues, field.name); 

        return (
            <FormControl
                fullWidth
                sx={{ mt: 1, mb: 1, width: fieldWidth }}
                variant={variant}
            >
                <InputLabel htmlFor={id} focused shrink>
                    {label}{" "}
                    {isRequired && (
                        <span className='required-asterisk'></span>
                    )}
                </InputLabel>
                <Autocomplete
                    id={id}
                    sx={{
                        "&.MuiAutocomplete-root .MuiInput-root .MuiInput-input":
                            {
                                padding: "20px 4px 4px 4px",
                            },
                    }}
                    options={options}
                    getOptionLabel={(option) => option.fieldLabel}
                    onChange={(event, value) =>
                        handleChange(event, value?.value)
                    }
                    onBlur={field.onBlur}
                    value={
                        options.find(
                            (option) => option.value === field.value
                        ) || null
                    }
                    renderInput={(params) => (
                        <div ref={params.InputProps.ref}>
                            <TextField
                                {...params}
                                name={field.name}
                                value={
                                    field.value || initialValue || ""
                                }
                                variant='standard'
                            />
                        </div>
                    )}
                    renderOption={(props, option) => (
                        <MenuItem
                            {...props}
                            disabled={option.isDisabled}
                            sx={{
                                fontSize: "16px",
                                lineHeight: "19px",
                                padding: "1rem",
                                position: "relative",
                                display: option.isDisabled
                                    ? "none"
                                    : "flex",
                            }}
                        >
                            {option.fieldLabel}
                        </MenuItem>
                    )}
                />
                <FormHelperText id={id} sx={{ color: "error.main" }}>
                    {error}
                </FormHelperText>
            </FormControl>
        );
      }}
    </Field>
  );
}

export default AutocompleteComponent;